import React,{Fragment,useEffect,useState} from 'react';
import {getCurrentPosition} from '../data-source/newEvents'
import Waypoint from './Waypoint'
import moment from 'moment'

const updatePosition = (setCurrentPosition, errorHandler) => {
    getCurrentPosition()
    .then( pos => {
        setCurrentPosition(pos)
        const speed = !isNaN(parseFloat(pos.gprmc_gs)) ? parseFloat(pos.gprmc_gs) : 0
        const timeout = speed < 2 ? 2 * 60000 : 15000
        setTimeout(() => {
            updatePosition(setCurrentPosition, errorHandler)
        }, timeout);
    })
    .catch( error => {
      console.log(error)
      errorHandler( error )
    })
}

const CurrentPosition = ({errorHandler}) => {
    const [currentPosition,setCurrentPosition] = useState(false)

    useEffect( () => {
        if(errorHandler){
            updatePosition(setCurrentPosition, errorHandler)
        }
    }, [errorHandler])

    const statusEmoji =  moment().diff(currentPosition.utc) > 1000 * 60 * 2 ? <span role='img' aria-label='Anchored'>&#9875;</span> : <span role='img' aria-label='Sailing'>&#128676;</span>

    return(
    <div className="card" style={{marginTop: "2.5rem"}}>
        <div class="card-header">Last Position {statusEmoji}</div>
        <div className="card-body">
            {currentPosition ? <Waypoint data={currentPosition}/> : <Fragment/>}
        </div>
    </div>);

}

export default CurrentPosition;